// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8e786412","container":"_73611f46","header":"_5655f3fe","learnMore":"_afb93740","benefits":"_9f446485","isTrade":"_ba6b86fd"};